import { NatureCustomData } from '../custom-datas/nature-custom-data';

export class MailCreateScanLotFullParams {
  //? scanLot : mandatory field
  scanLot: string;
  //? split : mandatory field
  split: string;

  barCode?: string;
  destinataireContactId?: number;
  scanLotCompleted?: boolean;
  fileDescription?: string;
  linkMailId?: number;
  serviceProprietaireId?: number;
  typeEntrantSortant?: string;
  confidentiel?: boolean;
  natureId?: number;
  sourceId?: number;
  refExpediteur?: string;
  expediteurLibre?: string;
  expediteurIdiAdmin?: number;
  expediteurId?: number;
  objet?: string;
  remarques?: string;
  dateDocument?: string;
  dateEcheance?: string;
  dateEntree?: string;
  classementId?: number;
  chemiseId?: number;
  classeurId?: number;
  referenceRecommande?: string;
  datePostale?: string;
  boiteArchive?: string;
  statutId?: number;
  annexeNonScannee?: boolean;
  annexeNonScanneeNombre?: number;
  annexeDiffusee?: boolean;
  centreNumerisationId?: number;
  natureCustomDatas?: NatureCustomData[];

  constructor(data?: Partial<MailCreateScanLotFullParams>) {
    Object.assign(this, data);
  }
}
